module.exports = __webpack_public_path__ + "static/media/ruzhizhiyinshouce.903e884d.png";